import { Component, OnInit } from '@angular/core';
import { IntegrationsService } from '../services/integrations.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditIntegrationComponent } from '../components/edit-integration/edit-integration.component';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.css']
})
export class IntegrationsComponent implements OnInit {


  integrations: any = [];
  constructor(
    private integrationsService: IntegrationsService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.getIntegrations();
  }

  async getIntegrations() {
    this.integrations = await new Promise(resolve =>
      this.integrationsService.getInegrations().subscribe(
        (res: any) => resolve(res.data)
      ));
  }

  onEdit(integration?: any) {
    const modalRef = this.modalService.open(EditIntegrationComponent, {
      size: 'md',
      centered: true,
      keyboard: false,
      backdrop: "static",
      modalDialogClass: 'add-reminder-modal',
    });

    modalRef.componentInstance.integration = integration
    modalRef.result.then((data) => {
      if (data?.data === true) {
        this.getIntegrations();
      }
    });
  }

}
